// Main configuration and initializations

(function(pes, $) {
  // NOTE: pes is an alias of the PESAPP global module

  // Declare components that have the same configurations so you won't
  // have to repeat yourself

  var sponsorConfig = {
    // Feed URL from sponsortool.penton.com
    // * Add it here so you won't need to repeat it
    url: 'https://sponsortool.penton.com/json/1570727',
    options: {
      // Sort by level, then title
      sorts: 'field_logo_sponsor_level,title'
    }
  };

  var sponsorLevel = {
    // Levels by number with custom headings
    '1': {
      heading: 'Platinum',
      columnClass: 'col-sm-6',
      sizeClass: 'platinum'
    },
    '2': {
      heading: 'Gold',
      columnClass: 'col-sm-6 col-lg-4',
      sizeClass: 'gold'
    },
    '3': {
      heading: 'Silver',
      columnClass: 'col-xs-6 col-sm-4 col-lg-3',
      sizeClass: 'silver'
    },
    '4': {
      heading: 'Marketing Partner',
      columnClass: 'col-xs-6 col-sm-4 col-lg-3',
      sizeClass: 'silver'
    }
  };

  var path = document.currentScript.src;		
	var regex = new RegExp('(https?://.*?\)/');
	var hostname = regex.exec(path)[1];
	var lookupurl = hostname+"/"+"lookuptool/exhibitor-console-api.php";
		
	$(document).ready(function(e){
      var companyID = $('#coid').data('co-id');
      var html = '';
      var appointmentHtml = '';
      var floorHtml = '';
      var selecteddata = {
            event_id: intRootEventID,
            company_id: companyID
			};
			$.ajax({
				url: lookupurl,
				method: "POST",
				data: selecteddata,
				success: function(result){
					var obj = JSON.parse(result);
					var day = obj.appointment.day;
					var time = obj.appointment.time;
					var booth = obj.floormn_result.booth;
					var hall = obj.floormn_result.hall;
					var fm_name = obj.floormn_result.fm_name;
					var fm_phone = obj.floormn_result.fm_phone;
					var ges_ese = obj.floormn_result.ges_ese;
					var fm_text_number = obj.floormn_result.fm_text_number;
					
					if((day != null && day != "") && (time != null && time != "")){
						appointmentHtml += 'Your Re-Sign Appointment is <b>' + day + ' </b>at <b>' + time+ ' </b><br/>';
					}else{
						appointmentHtml = '<span>No Appointments found.</span>';
					}
					
					$("#appointments").show();
					$('#appointments').html(appointmentHtml);				
					
					if((booth !=null && booth != "")){
						floorHtml += 'The contact person details for your booth number: <b>' + booth + '</b> in <b>' + hall + '</b> is Floor Manager: <b> ' + fm_name + ' </b>Phone: <b>' + fm_phone + ' </b> and GES: <b> ' + ges_ese + ' </b>Text Number: <b>' + fm_text_number+ '</b><br/>';
					}else{
						floorHtml = '<span>No Booth details and Floor Manager details found.</span>'; 
					}
					$("#floormanager").show();
					$('#floormanager').html(floorHtml);
				}
			});
	});

  // use pes.extend()

  var sponsors = pes.extend(pes.sponsor, sponsorConfig);
  sponsors = pes.extend(sponsors, {
    options: sponsorLevel
  });
  var sponsorIndex = pes.extend(pes.sponsorIndex, sponsorConfig);
  sponsorIndex = pes.extend(sponsorIndex, {
    levels: sponsorLevel
  });

  // sponsors and sponsorIndex can be initialized inside
  // $(document).ready(function() {...}) below with additional
  // configurations added; like this:
  //  * pes.extend(sponsors, { <config object> }).init();
  // or initialize it as is, like this:
  //  * sponsors.init();

  // Initialize components, one initialization per view element
  // use pes.extend().init()

  $(document).ready(function() {


    // Sponsor carousel
    pes.extend(sponsors, {
        view: '#sponsor-carousel',
        options: {
          // sorts: 'randomize' with levels defined will randomize sponsors
          // within each level group, otherwise 'randomize' with levels: false
          // will be completly random
          sorts: 'randomize',
          // Only displays Level 1 and 2 sponsors
          // levels: '1,2',
          // How many logos are displayed per slide
          // logosPerSlide: 3,
          // The dispaly size of each logo in the carousel
          // sizeClass: 'gold',
          // Most components include a default template. However, you can add or
          // override a template a few ways.
          // Override a template:
          // 1) As an HTML attribute on the view element: data-template="some-template"
          // 2) As below
          // * NOTE: Both ways also support jQuery selectors
          template: 'base-sponsor-carousel'
          // Templates also support jQuery selectors, so '#mytpl-sponsor-carousel'
          // (note the '#' selector)would correspond to a an element on the page, like this:
          // <script id="mytpl-sponsor-carousel" type="text/x-handlebars-template"> <your html> </script>
        }
      }
    ).init();

    // Sponsor list
    pes.extend(sponsors, {
        view: '#sponsor-list',
        options: {
          // Define the template
          template: 'base-sponsor-list-cards',
          // Alter the sort
          // sorts: 'field_logo_opportunity,title',
          toggleAll: '#sponsor-list-toggle'
        }
      }
    ).init();

    // Sponsor index
    pes.extend(sponsorIndex, {
      view: '#sponsor-index',
    }).init();

    // Carousel
    pes.extend(pes.carousel, {
      view: '.pes-carousel',
      options: {
        // Default options shown below
        controls: {
          show: true,
          template: 'base-carousel-controls'
        },
        indicators: {
          show: true,
          template: 'base-carousel-indicators'
        }
      }
    }).init();

    // Gallery example
    pes.extend(pes.gallery, {
        src: '#model-gallery-example',
        view: '#gallery-example',
        options: {
          // Add a cooler gallery for my site
          // template: 'my-gallery'
        }
      }
    ).init();

    // Products list
    pes.extend(pes.product, {
        // Feed URL from inMotion hosting for the a2z exhibitor list
        // * Add the a2z Event ID to return all exhibitors for an event
        // * PESAPP.product callback filters the result to companies with products only
        url: '//pentonweb.com/api/a2z/2016/ExhibitorProvider.php?id=644',
        view: '#product-list',
        controller: '#product-list-controller'
      }
    ).init();

    $(".showAll").on("click", function () {
      $("#item-informa-top-bar").attr("class","collapse in");
      var expand_collpase_elem = $(this);
      var expandall = expand_collpase_elem.attr("data-expandall");
  
      $(".panel-title")
        .find("a")
        .each(function () {
          var titleElement = $(this);
          if (expandall == "true") {
            $(".collapse").collapse("hide");
            $(".showAll").html("Expand All");
            $(this).find("span").removeClass("fa-chevron-up").addClass("fa-chevron-down");
            expand_collpase_elem.attr("data-expandall", "false");
          } else {
            $(".collapse").collapse("show");
            $(".showAll").html("Collapse All");
            $(this).find("span").removeClass("fa-chevron-down").addClass("fa-chevron-up");
            expand_collpase_elem.attr("data-expandall", "true");
          }
        });
        $("#item-informa-top-bar").attr("class","collapse");
    });
  
  $(".resetall").on("click", function () {
       $(".showAll").html("Expand All");
  $(".showAll").attr("data-expandall", "false");
    }); 

    pes.extend(pes.sponsorOpps, {
      view: '#sponsorship-opps',
       url: 'https://opps.informamarkets.com/category/nbj-summit-2022/?json=get_posts&post_type=opportunity&orderby=title&order=asc&count=-1&exclude=comments,comment_count,comment_status,author,date,modified,tags,url,status',
   controller: '#sponsor-opps-controller',
       options: {
         contact: {
           link: 'https://www.expowest.com/en/exhibitor-resources/contact-your-account-manager.html' // Link to a contact page, or remove to hide link
         },
         inclusion: {
           link: 'https://www.expowest.com/en/exhibitor-resources/sponsorship-levels.html' // Link to an inclusions page, or remove to hide link
         },
     formatConfig: {
         propertyName: 'opp_format_use',
         formats: {
           '1': {
       label: 'Virtual',
       class: 'opp-format'
           },
           '2': {
       label: 'In-Person',
       class: 'opp-format'
           },
           '3': {
       label: 'both',
       class: 'opp-format'
           },
         }
       },
         // Update below if using types
         typeConfig: {
         propertyName: 'opp_type_use',
         types: {
           'Promotional Items': {
             sort: '1',
       label: 'Promotional Items',
             class: 'opp-type'
           },
           'Activities & Events': {
             sort: '2',
       label: 'Activities & Events',
             class: 'opp-type'
           },
           'Additional Sponsorship Opportunities': {
             sort: '3',
       label: 'Additional Sponsorship Opportunities',
             class: 'opp-type'
           },
           'Convention Center & Bayside Foyer Branding': {
             sort: '4',
       label: 'Convention Center & Bayside Foyer Branding',
             class: 'opp-type'
           },
           'Education Session Underwriting': {
             sort: '5',
       label: 'Education Session Underwriting',
             class: 'opp-type'
           },
           'Education': {
             sort: '6',
       label: 'Education',
             class: 'opp-type'
           },
           'Exterior Building Branding': {
             sort: '7',
       label: 'Exterior Building Branding',
             class: 'opp-type'
           },
           'Expo Hall Opportunities': {
             sort: '8',
       label: 'Expo Hall Opportunities',
             class: 'opp-type'
           },
           'Digital Advertising': {
             sort: '9',
       label: 'Digital Advertising',
             class: 'opp-type'
           },
           'Graphics': {
             sort: '10',
       label: 'Graphics',
             class: 'opp-type'
           },
           'Lobby Area Branding': {
             sort: '11',
       label: 'Lobby Area Branding',
             class: 'opp-type'
           },
           'Media Sponsorships': {
             sort: '12',
       label: 'Media Sponsorships',
             class: 'opp-type'
           },
           'Print Advertising': {
             sort: '13',
       label: 'Print Advertising',
             class: 'opp-type'
           },
           'Promotional Items': {
             sort: '14',
       label: 'Promotional Items',
             class: 'opp-type'
           },
           'Registration Sponsorships': {
             sort: '15',
       label: 'Registration Sponsorships',
             class: 'opp-type'
           },
           'Sampling': {
             sort: '16',
       label: 'Sampling',
             class: 'opp-type'
           },
           'Sponsored Content': {
             sort: '17',
       label: 'Sponsored Content',
             class: 'opp-type'
           },
           'Show Services': {
             sort: '18',
       label: 'Show Services',
             class: 'opp-type'
           },
           'Virtual Tour Available': {
             sort: '19',
       label: 'Virtual Tour Available',
             class: 'opp-type'
           }
         }
       },
         // Update below if using levels
         levelConfig: {
           propertyName: 'opp_level_use',
           levels: {
       '0': {
               label: '',
               class: '',
       
             },
             '1': {
               label: 'Platinum',
               class: 'bg-platinum',
       
             },
             '2': {
               label: 'Gold',
               class: 'bg-gold'
             },
             '3': {
               label: 'Silver',
               class: 'bg-silver'
             },
             '4': {
               label: 'Title Sponsor',
               class: 'bg-silver'
             },
             '5': {
               label: 'Major Sponsor',
               class: 'bg-silver'
             },
             '6': {
               label: 'Sponsor',
               class: 'bg-silver'
             },
             '7': {
               label: 'Premier Title',
               class: 'bg-silver'
             }
           }
         }
       }
     }
   ).init();

    pes.extend(pes.exhibitor, {
      url: "//pentonweb.com/api/a2z/2016/ExhibitorProvider.php?id=653",
      view: "#exhibitor-list",
      controller: "#exhibitor-list-controller"
    }).init();

    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-08",
      options: {
        dates: ["03/08/2017"]
      }
    }).init();
    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-09",
      options: {
        dates: ["03/09/2017"]
      }
    }).init();
    pes.extend(pes.session, {
      url: "//pentonweb.com/api/a2z/2016/ConferenceProvider.php?id=653",
      view: "#session-list-mar-10",
      options: {
        dates: ["03/10/2017"]
      }
    }).init();

    // Sponsor carousel for a2z session pages
    pes.extend(pes.sessionSponsor, {
      // Club Industry Show 2017 sponsor data
      url: "//sponsortool.penton.com/json/1526541",
      // Following class should be added to SessionDetails_ID.xslt, Sessions_Summary_ID.xslt
      view: ".session-sponsor-carousel",
      options: {
        /* Default options as follows: */
        //   template: "session-sponsor-carousel",
        //   logosPerSlide: 1,
        //   logoLinks: false,
        //   sorts: "randomize",
        //   sizeClass: "gold",
        // Configure levels
        "1": {
          "heading": "Sponsored By"
        },
        "2": {
          "heading": "Hosted By"
        }
      }
    }).init();

    // Exhibitor sponsor logos
    pes.extend(pes.sessionSponsor, {
      // Should be same URL as used in main sponsor list
      url: "https://sponsortool.penton.com/json/1570727",
      // Following class should be added to SessionDetails_ID.xslt, Sessions_Summary_ID.xslt
      view: ".exhibitor-sponsor-logo",
      options: {
        /* Default options as follows: */
        //   template: "session-sponsor-carousel",
        //   logosPerSlide: 1,
        //   logoLinks: false,
        //   sorts: "randomize",
        sizeClass: "silver",
        "1": {
          "heading": ""
        },
        "2": {
          "heading": ""
        },
        "3": {
          "heading": ""
        },
        "4": {
          "heading": ""
        }
      }
    }).init();

    // BONUS: An example sub-module
    // See src/js/components/my-example.js and src/js/templates/my-example.html
    // pes.extend(pes.myExample).init();

  });
}(PESAPP, jQuery));
